import React from "react";

function normalize(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\./g, "")
    .replace(/\s+/g, " ");
}

function initials(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

let SIMPLE_ICON_MAP;

function getSimpleIconMap() {
  if (SIMPLE_ICON_MAP) return SIMPLE_ICON_MAP;

  // eslint-disable-next-line global-require
  const si = require("simple-icons");

  SIMPLE_ICON_MAP = {
    angular: si.siAngular,
    react: si.siReact,
    "react native": si.siReact,
    nextjs: si.siNextdotjs,
    "next js": si.siNextdotjs,
    "nextdotjs": si.siNextdotjs,
    typescript: si.siTypescript,
    "tailwind css": si.siTailwindcss,
    tailwind: si.siTailwindcss,
    "tailwindcss": si.siTailwindcss,
    angularjs: si.siAngular,
    vue: si.siVuedotjs,
    vuejs: si.siVuedotjs,

    nodejs: si.siNodedotjs,
    "node js": si.siNodedotjs,
    node: si.siNodedotjs,
    python: si.siPython,
    fastapi: si.siFastapi,
    graphql: si.siGraphql,
    docker: si.siDocker,
    kubernetes: si.siKubernetes,

    aws: si.siAmazonwebservices,
    "amazon web services": si.siAmazonwebservices,
    "google cloud": si.siGooglecloud,
    gcp: si.siGooglecloud,

    postgresql: si.siPostgresql,
    postgres: si.siPostgresql,
    mongodb: si.siMongodb,
    redis: si.siRedis,
    firebase: si.siFirebase,
    mysql: si.siMysql,

    flutter: si.siFlutter,
    swift: si.siSwift,
    android: si.siAndroid,
    ios: si.siIos,

    openai: si.siOpenai,
  };

  return SIMPLE_ICON_MAP;
}

function ensureVisibleHex(hex) {
  if (!hex) return undefined;
  const h = String(hex).replace("#", "").toLowerCase();
  if (h === "000000") return "ffffff";
  return h;
}

/**
 * Tech logo renderer.
 * Uses real brand SVG paths (Simple Icons) + a consistent fallback.
 */
export default function TechLogo({ name, className = "" }) {
  const key = normalize(name);
  const keyNoSpace = key.replace(/\s/g, "");
  const map = getSimpleIconMap();

  const icon = map[key] || map[keyNoSpace];

  if (icon && icon.path) {
    const hex = ensureVisibleHex(icon.hex);
    const color = hex ? `#${hex}` : undefined;
    return (
      <span
        className={`tech-logo ${className}`.trim()}
        aria-hidden="true"
        style={color ? { color } : undefined}
        title={icon.title || name}
      >
        <svg className="tech-logo-svg" viewBox="0 0 24 24" aria-hidden="true">
          <path d={icon.path} fill="currentColor" />
        </svg>
      </span>
    );
  }

  return (
    <span className={`tech-logo ${className}`.trim()} aria-hidden="true">
      <span className="tech-logo-fallback">{initials(name)}</span>
    </span>
  );
}

